var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCard',{staticClass:"b-none"},[_c('CCardBody',{staticClass:"p-0 overflow-unset mt--15px"},[_c('div',{attrs:{"id":"main"}},[_c('br'),_c('div',{ref:"ibDurSlider",attrs:{"id":"ibDurSlider"}}),_c('br')])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }